module.exports = __webpack_public_path__ + "img/lom_banner.6c40ad1d.png";